//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { commonApi } from '@/common/index';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { providersOptions,promotionList , resetTextBylangKey} from '../../../libs/options.js'
import Langs from '../../components/Lang/index.vue'

  export default{
    components: { awesomeSwiper: swiper,swiperSlide ,Langs},
    props: {
      tabOptions: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
     data() {
      return {
        swiperOptions: {
          // 配置Swiper参数
          slidesPerView: 3.3,
          // slidesPerColumn: 8,
          slidesPerColumnFill : 'row',
          spaceBetween: 10,
          // grid: {
          //   fill: 'column',
          //   rows: 2,
          // },
        },
        providersOptions: [],
        promotionList: [],
        problemLists: [],

      }
    },
    created() {
      const storedArray = sessionStorage.getItem('homeNav');
        if (storedArray) {
            this.tabOptions = JSON.parse(storedArray);
        }
      this.providersOptions = providersOptions
      this.promotionList = resetTextBylangKey(promotionList, this.$t('provider'))
      this._getList()
    },
    methods: {
      handlePath(item){
        this.$router.push({ path: item.path })
      },
      handleService({id, name}) {
        this.$router.push({
          path: '/Service/problems/details',
          query: {id, name}
        })
      },
      _getList() {
        if (sessionStorage.getItem('getArticleType')) {
            this.problemLists = JSON.parse(sessionStorage.getItem('getArticleType'));
        } else {
          commonApi.HELP.getArticleType().then((data) => {
            this.problemLists = data
            if (data) {
                sessionStorage.setItem("getArticleType", JSON.stringify(data));
            }
          }).catch((err) => {})
        }
      },
      handleCopy($id){
        const ele = document.getElementById($id)
        if (copy(ele)) this.$showToast({ text: this.$t('others').copySuceess, time: 2000, type: 'success' })
      },
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/components/home-footer.vue